import styles from "./index.module.css";

type Stack = {
  name: string;
  glyph: string;
  bg: string;
  fg: string;
};

const STACKS: Stack[] = [
  { name: "Next.js", glyph: "N", bg: "#000", fg: "#fff" },
  { name: "React", glyph: "⚛", bg: "#20232a", fg: "#61dafb" },
  { name: "Python", glyph: "py", bg: "#306998", fg: "#ffd43b" },
  { name: "Go", glyph: "Go", bg: "#00add8", fg: "#fff" },
  { name: "Node", glyph: "JS", bg: "#3c873a", fg: "#fff" },
  { name: "Rust", glyph: "🦀", bg: "#2b2b2b", fg: "#deb887" },
  { name: "Ruby", glyph: "💎", bg: "#cc342d", fg: "#fff" },
  { name: "PHP", glyph: "php", bg: "#777bb4", fg: "#fff" },
  { name: "Docker", glyph: "🐳", bg: "#0db7ed", fg: "#fff" },
  { name: "Postgres", glyph: "🐘", bg: "#336791", fg: "#fff" },
  { name: "FastAPI", glyph: "⚡", bg: "#009688", fg: "#fff" },
  { name: "Astro", glyph: "▲", bg: "#0d0e10", fg: "#ff5d01" }
];

export const WhatCanIDeploy = () => (
  <section id="stacks" className={styles.section}>
    <div className={styles.sectionHead}>
      <div className={styles.sectionKicker}>works with whatever you wrote</div>
      <h2 className={styles.sectionTitle}>
        If it runs on your laptop,
        <br />
        <em>it&apos;ll run on ours.</em>
      </h2>
      <p className={styles.sectionSub}>
        Next.js, Python, Go, Rust, Ruby, PHP, your weird side project — we got it. If it has a
        Dockerfile, even better.
      </p>
    </div>
    <div className={styles.stackGrid}>
      {STACKS.map(s => (
        <div key={s.name} className={styles.stackCard}>
          <div
            className={styles.stackGlyph}
            style={{ background: s.bg, color: s.fg }}
            aria-hidden="true"
          >
            {s.glyph}
          </div>
          <div className={styles.stackName}>{s.name}</div>
        </div>
      ))}
    </div>
    <div className={styles.stackFoot}>
      &hellip;and much more.{" "}
      <a href="/faq" className={styles.linkAccent}>
        See the FAQ →
      </a>
    </div>
  </section>
);
